import { AxiosResponse } from 'axios';

// Helper.
import API from '../Api';
// Types.
import { Config } from '../types/config';

export const fetchConfiguration = async (): Promise<Config> => {
  const config: AxiosResponse<Config> = await API({
    method: 'get',
    url: `/v1/configuration`,
  }).catch((error) => {
    if (error.response) {
      return error.response;
    }
  });

  return config.data;
};
